/* eslint-disable react/require-default-props */
import React from "react";
import styled from "styled-components";
import { Badge } from "@xfrontend/xui-react-plus";
import { RISK_LEVEL_MAP } from "#/types/xecguard";
import { useRiskLevelLabel } from "#/i18n/hooks";

type RiskLevelTagProps = {
  level: number;
  className?: string;
};

const StyledTag = styled(Badge)<{ $color: string; $bg: string }>`
  display: inline-block;
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 14px;
  line-height: 1;
  color: ${(props) => props.$color};
  background-color: ${(props) => props.$bg};
`;

const RiskLevelTag = ({
  level,
  className,
}: RiskLevelTagProps): JSX.Element | null => {
  const info = RISK_LEVEL_MAP[level];
  const label = useRiskLevelLabel(level);
  if (!info) return null;

  return (
    <StyledTag bg="" $color={info.color} $bg={info.bg} className={className}>
      {label}
    </StyledTag>
  );
};

export default RiskLevelTag;
